
export default () => {
	return window.APP_CONFIG;
};


// WEBPACK FOOTER //
// ./frontend/config.js